import { Component } from '@angular/core';

@Component({
  selector: 'app-cards-4',
  templateUrl: './cards-4.component.html'
})
export class Cards4Component {




    }
